export const conf2AccountFirstName = {
  type: "string",
  minLength: 0,
  maxLength: 255,
  transform: ["trim", "toLowerCase"]
};
